import {LitElement} from 'lit';
import {html} from 'lit/html.js';

import css from './tt-page-error.pcss';

import './../tt-page/tt-page'
import './../tt-toolbar/tt-toolbar'

import {TTUtil} from "../../utils/tt-util";

import '@polymer/paper-icon-button'

export default class TTPageError extends LitElement {

    static get properties() {
        return {
            user: {type: Object},
            data: {type: Object},
        };
    }

    static get styles() {
        return [css];
    }

    render() {
        return html`
<tt-page>
    <div slot="header">
        <tt-toolbar .user=${this.user}></tt-toolbar>
    </div>

    <div slot="body">
        <div class="heading">
            <h1>${this.data?.title}</h1>
    
            <!-- reload button -->
            ${this.data?.showRetry ? html`<paper-icon-button icon="refresh" @click=${this.retry} ></paper-icon-button>` : html``}
        </div>

        <p>${this.data?.text}</p>
    </div>
</tt-page>
`;
    }

    retry() {
        TTUtil.getApp(this).refreshCurrent();
    }

}

window.customElements.define('tt-page-error', TTPageError);
